import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@formrails/environments';
import { DeliveryPartner, Funder, ProgrammeFamily } from '@formrails/shared/util-models';
import { DeliveryPartnerDto } from '../dtos/Responses/deliveryPartnerDto';
import { FunderDto } from '../dtos/Responses/funderDto';
import { ProgrammeFamilyDto } from '../dtos/Responses/programmeFamilyDto';
import { fromDeliveryPartnerDto, fromFunderDto, fromProgrammeFamilyDto } from './reference-data-api.mappers';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDataApiService {
  private readonly http = inject(HttpClient);
  private readonly funderBase = `${environment.programmeApi}/funder`;
  private readonly deliveryPartnerBase = `${environment.programmeApi}/deliverypartner`;
  private readonly programmeFamilyBase = `${environment.programmeApi}/programmefamily`;

  getFunders(): Observable<Funder[]> {
    return this.http.get<FunderDto[]>(this.funderBase).pipe(map(dtos => dtos.map(fromFunderDto)));
  }

  getDeliveryPartners(): Observable<DeliveryPartner[]> {
    return this.http
      .get<DeliveryPartnerDto[]>(this.deliveryPartnerBase)
      .pipe(map(dtos => dtos.map(fromDeliveryPartnerDto)));
  }

  getProgrammeFamilies(): Observable<ProgrammeFamily[]> {
    return this.http
      .get<ProgrammeFamilyDto[]>(this.programmeFamilyBase)
      .pipe(map(dtos => dtos.map(fromProgrammeFamilyDto)));
  }
}
